import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'

export default {
  computed: {
    ...mapState({
      Common: 'Common',
      SpaceManagement: 'SpaceManagement',
      Unit: 'Unit',
      docFontSize:'fontSize',
      leftMenuShow:'leftMenuShow',
      topShow: 'topShow'
    })
  },
  methods: {
    ...mapMutations({
      setLeftMenuShow_M:'SET_LEFTMENU_SHOW',
      SETUPDATE: 'SpaceManagement/SETUPDATE',
      SETWORDS: 'SpaceManagement/SETWORDS',
      SETUPLOAD: 'SpaceManagement/SETUPLOAD',
      SETLOGNUMBERDETAILS: 'SpaceManagement/SETLOGNUMBERDETAILS',
      SETQRCODEVISIBLE: 'SpaceManagement/SETQRCODEVISIBLE',
      SETQRCODEVISIBLEDOWN: 'SpaceManagement/SETQRCODEVISIBLEDOWN',
      SETQRCODEVISIBLECLAIMAPP: 'SpaceManagement/SETQRCODEVISIBLECLAIMAPP',
      SETQRCODEVISIBLECLAIMALL: 'SpaceManagement/SETQRCODEVISIBLECLAIMALL',
      SETQRCODEVISIBLECLAIM: 'SpaceManagement/SETQRCODEVISIBLECLAIM',
      SETQRCODEVISIBLEDOWNCLAIMAPP: 'SpaceManagement/SETQRCODEVISIBLEDOWNCLAIMAPP',
      SETQRCODEVISIBLEDOWNCLAIM: 'SpaceManagement/SETQRCODEVISIBLEDOWNCLAIM',
      SETQRCODEVISIBLEDOWNCLAIMALL: 'SpaceManagement/SETQRCODEVISIBLEDOWNCLAIMALL',
      TOSHOWPOSTER: 'SpaceManagement/TOSHOWPOSTER',
      TOSHOWPOSTERCODE: 'SpaceManagement/TOSHOWPOSTERCODE',
      TOSHOWBGURL: 'SpaceManagement/TOSHOWBGURL',
      TOSHOWBGURLCODE: 'SpaceManagement/TOSHOWBGURLCODE',
      FONTCOLOR: 'SpaceManagement/FONTCOLOR',
      FONTCOLORCODE: 'SpaceManagement/FONTCOLORCODE',
      FREEZINGVISITORDIALOG: 'SpaceManagement/FREEZINGVISITORDIALOG',
      UNFREEZEDIALOG: 'SpaceManagement/UNFREEZEDIALOG',
      VISITORFROZENCONTENTNEW: 'SpaceManagement/VISITORFROZENCONTENTNEW',
      VISITORFROZENCONTENT: 'SpaceManagement/VISITORFROZENCONTENT',
      PHOTOALBUMDATA: 'SpaceManagement/PHOTOALBUMDATA',
      PHOTOALBUMDIALOG: 'SpaceManagement/PHOTOALBUMDIALOG',
      PHOTOALBUMDETAILS: 'SpaceManagement/PHOTOALBUMDETAILS',
      UPDATEFILELIST: 'SpaceManagement/UPDATEFILELIST',
      PAGEINFO: 'SpaceManagement/PAGEINFO',
      ISCANNEXT: 'SpaceManagement/ISCANNEXT',
      SETCANUPDATE: 'SpaceManagement/SETCANUPDATE',
    }),
    ...mapActions({
      findById: 'SpaceManagement/findById',
      findByIdHalf: 'SpaceManagement/findByIdHalf',
      findByIdAnother: 'SpaceManagement/findByIdAnother',
      findByIdMiddle: 'SpaceManagement/findByIdMiddle',
      findUserDmRelationById: 'SpaceManagement/findUserDmRelationById',
      findSignInById: 'SpaceManagement/findSignInById',
      findAllBgTemplate: 'SpaceManagement/findAllBgTemplate',
      findAllBgTemplateV2: 'SpaceManagement/findAllBgTemplateV2',
      findAllMusicTemplate: 'SpaceManagement/findAllMusicTemplate',
      editById: 'SpaceManagement/editById',
      getOSSsignature: 'Common/getOSSsignatureAnother',
      getOSSsignatureAgain: 'Common/getOSSsignatureAgain',
      findAllListCreate: 'SpaceManagement/findAllListCreate',
      addOrEdit: 'SpaceManagement/addOrEdit',
      editUpdateStateById: 'SpaceManagement/editUpdateStateById',
      editUploadStateById: 'SpaceManagement/editUploadStateById',
      editCemeteryById: 'SpaceManagement/editCemeteryById',
      editVisitorFrozenById: 'SpaceManagement/editVisitorFrozenById',
      editSpaceFrozenById: 'SpaceManagement/editSpaceFrozenById',
      getUrlDataSource: 'SpaceManagement/getUrlDataSource',
      cancelUpdateStateById: 'SpaceManagement/cancelUpdateStateById',
      getUrlConnectionCode: 'SpaceManagement/getUrlConnectionCode',
      getOssFileState: 'SpaceManagement/getOssFileState',
      cancelUploadStateById: 'SpaceManagement/cancelUploadStateById',
      editUploadById: 'SpaceManagement/editUploadById',
      findUploadByDmId: 'SpaceManagement/findUploadByDmId',
      saveLog: 'SpaceManagement/saveLog',
      delUploadById: 'SpaceManagement/delUploadById',
      findPhotoCategory: 'SpaceManagement/findPhotoCategory',
      addOrEditPhotoCategory: 'SpaceManagement/addOrEditPhotoCategory',
      delPhotoCategory: 'SpaceManagement/delPhotoCategory',
      findPhotoByCategoryId: 'SpaceManagement/findPhotoByCategoryId',
      addPhotoByCategoryId: 'SpaceManagement/addPhotoByCategoryId',
      delPhotoById: 'SpaceManagement/delPhotoById',
      editPhotoRemark: 'SpaceManagement/editPhotoRemark',
      editPhotoPosition: 'SpaceManagement/editPhotoPosition',
      findMovePhotoCategory: 'SpaceManagement/findMovePhotoCategory',
      movePhoto: 'SpaceManagement/movePhoto',
      getUserCount: 'SpaceManagement/getUserCount',
      dragPhoto: 'SpaceManagement/dragPhoto',
      getTemplateAllList_A:"Unit/getTemplateAllList_A",
      getClaimCodeUrl: 'SpaceManagement/getClaimCodeUrl',
      getClaimCodeUrlAll: 'SpaceManagement/getClaimCodeUrlAll',
      getLifeAlbumByDmId: 'SpaceManagement/getLifeAlbumByDmId',
      findLifeAlbumPhotoAllByDmId: 'SpaceManagement/findLifeAlbumPhotoAllByDmId',
      addLifeAlbumPhotoByDmId: 'SpaceManagement/addLifeAlbumPhotoByDmId',
      draggableLifeAlbumPhoto: 'SpaceManagement/draggableLifeAlbumPhoto',
      delLifeAlbumPhotoByIds: 'SpaceManagement/delLifeAlbumPhotoByIds',
      findLifeAlbumTemplateBg: 'SpaceManagement/findLifeAlbumTemplateBg',
      findLifeAlbumTemplateMusic: 'SpaceManagement/findLifeAlbumTemplateMusic',
      findLifeAlbumSubtitle1: 'SpaceManagement/findLifeAlbumSubtitle1',
      findLifeAlbumSubtitle2: 'SpaceManagement/findLifeAlbumSubtitle2',
      findLifeAlbumSubtitle3: 'SpaceManagement/findLifeAlbumSubtitle3',
      addLifeAlbumByDmId: 'SpaceManagement/addLifeAlbumByDmId',
      addLifeAlbumListener: 'SpaceManagement/addLifeAlbumListener',
      cleanLifeAlbumByDmId: 'SpaceManagement/cleanLifeAlbumByDmId',
      updateLifeAlbumStateByDmId: 'SpaceManagement/updateLifeAlbumStateByDmId',
      findLifeAlbumPhotoFrameById: 'SpaceManagement/findLifeAlbumPhotoFrameById',
      editLifeAlbumPhotoCropperUrl: 'SpaceManagement/editLifeAlbumPhotoCropperUrl',
      cancelLifeAlbumPhotoCropperUrl: 'SpaceManagement/cancelLifeAlbumPhotoCropperUrl',
      editLifeAlbumPhotoAiUrl: 'SpaceManagement/editLifeAlbumPhotoAiUrl',
      confirmLifeAlbumPhotoAiUrl: 'SpaceManagement/confirmLifeAlbumPhotoAiUrl',
      replaceLifeAlbumPhotoAiUrl: 'SpaceManagement/replaceLifeAlbumPhotoAiUrl',
      replaceLifeAlbumPhotoAiUrlAll: 'SpaceManagement/replaceLifeAlbumPhotoAiUrlAll',
      uploadLifeAlbumVideoToDmPhoto: 'SpaceManagement/uploadLifeAlbumVideoToDmPhoto',
      downloadLifeAlbumVideo: 'SpaceManagement/downloadLifeAlbumVideo',
      compositeLifeAlbumPhotoAiHeadPic: 'SpaceManagement/compositeLifeAlbumPhotoAiHeadPic',
      callLifeAlbumPhotoAi: 'SpaceManagement/callLifeAlbumPhotoAi',
      uploadLifeAlbumPhotoToDmPhoto: 'SpaceManagement/uploadLifeAlbumPhotoToDmPhoto',
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/PartII/SpaceDetails/components/Mixins.js